/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import "./src/styles/global.css";
import { bindHumanSignal } from "./src/utils/analytics";

export function onClientEntry() {
  bindHumanSignal();
}
